import { render, staticRenderFns } from "./MaterialTypesSettingsDetailPage.vue?vue&type=template&id=fda9e948"
import script from "./MaterialTypesSettingsDetailPage.vue?vue&type=script&lang=js"
export * from "./MaterialTypesSettingsDetailPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports